import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback, useEffect, useMemo, useRef } from 'react';
import { toast } from 'react-toastify';
import MaterialTable, { MTableBodyRow, MTableFilterRow, MTableToolbar, } from '@material-table/core';
import { TablePagination } from '@mui/material';
import { ErrorToast } from '../../components/Toasts';
import { tableRowHeight } from '../../utils/constants';
import { isSearchValid } from '../../utils/isSearchValid';
import { tableIcons } from './icons';
const Table = (props) => {
    var _a, _b, _c;
    const { childrenIdFieldName, actionCellNoFlex } = props;
    // required for row scrolling usage (utils/scrollToRow.ts)
    const RowComponent = useCallback((props) => {
        var _a, _b;
        return (_jsx(MTableBodyRow, Object.assign({ "data-id": ((_a = props === null || props === void 0 ? void 0 : props.data) === null || _a === void 0 ? void 0 : _a.id) ? `${props.data.id}` : 0, "data-children-id": (_b = props.data[childrenIdFieldName]) !== null && _b !== void 0 ? _b : 0 }, props)));
    }, [childrenIdFieldName]);
    // required for styling filterRow
    const FilterRowComponent = useCallback((rowProps) => {
        var _a;
        return (_jsx(MTableFilterRow, Object.assign({}, rowProps, { filterRowStyle: Object.assign({ top: 41, backgroundColor: 'white', zIndex: 1, position: 'sticky' }, (_a = props.options) === null || _a === void 0 ? void 0 : _a.filterRowStyle) })));
    }, [props.options]);
    const PaginationComponent = useCallback((props) => _jsx(TablePagination, Object.assign({ "data-testid": "pagination" }, props)), []);
    const ToolbarComponent = useCallback((props) => (_jsx(MTableToolbar, Object.assign({ classes: { searchField: 'material-table-search-field' } }, props))), []);
    const actionFlexStyle = actionCellNoFlex
        ? {}
        : {
            display: 'flex',
            width: '100%',
        };
    //Can't be typed as HTMLDivElement since property 'tableContainerDiv' does not exist on type 'HTMLDivElement'
    const tableRef = useRef(null);
    const onPageChangeWithScrollTop = (...params) => {
        var _a, _b, _c;
        if (props.onPageChange) {
            //Scroll table to top
            (_c = (_b = (_a = tableRef === null || tableRef === void 0 ? void 0 : tableRef.current) === null || _a === void 0 ? void 0 : _a.tableContainerDiv) === null || _b === void 0 ? void 0 : _b.current) === null || _c === void 0 ? void 0 : _c.scroll({
                top: 0,
            });
            const [page, pageSize] = params;
            props.onPageChange(page, pageSize);
        }
    };
    useEffect(() => {
        if (props.setFirstRow && props.data) {
            setTimeout(() => {
                var _a;
                // accessing the first row of the table
                const data = props.data;
                const firstRow = document.querySelector(`[data-id="${(_a = data[0]) === null || _a === void 0 ? void 0 : _a.id}"]`);
                if (firstRow) {
                    firstRow.click();
                }
            }, 1000);
        }
    }, [props.data, props.setFirstRow]);
    const columns = useMemo(() => props.columns.map((column) => (Object.assign(Object.assign({}, column), { 
        // to disable Material-Table default filtering (show all data from backend)
        customFilterAndSearch: props.disableDefaultSearchAndFilter
            ? () => true
            : column.customFilterAndSearch }))), [props.columns, props.disableDefaultSearchAndFilter]);
    const hiddenSortArrows = useMemo(() => ({
        SortArrow: () => _jsx(_Fragment, {}),
    }), []);
    const onSearchChange = (value) => {
        var _a;
        if (isSearchValid(value)) {
            return (_a = props.onSearchChange) === null || _a === void 0 ? void 0 : _a.apply(null, [value]);
        }
        else {
            toast.error(_jsx(ErrorToast, { message: "Unexpected character entered" }));
        }
    };
    return (_jsx("div", Object.assign({ className: ((_a = props.options) === null || _a === void 0 ? void 0 : _a.filtering) ? 'material-table-with-filters' : '' }, { children: _jsx(MaterialTable, Object.assign({}, props, { onSearchChange: onSearchChange, columns: columns, tableRef: tableRef, style: Object.assign({ overflow: 'auto', border: 0, boxShadow: 'none' }, props.style), components: Object.assign({ Pagination: PaginationComponent, Row: RowComponent, Toolbar: ToolbarComponent, FilterRow: FilterRowComponent }, props.components), icons: Object.assign(Object.assign(Object.assign({}, (props.hideSortingArrows && hiddenSortArrows)), tableIcons), props.icons), localization: Object.assign(Object.assign({ header: {
                    actions: '',
                } }, props.localization), { pagination: {
                    firstAriaLabel: 'first-page',
                    previousAriaLabel: 'previous-page',
                    nextAriaLabel: 'next-page',
                    lastAriaLabel: 'last-page',
                    labelRowsSelect: '',
                } }), onPageChange: onPageChangeWithScrollTop, options: Object.assign({ actionsColumnIndex: -1, pageSizeOptions: [5, 10, 25, 50, 100, 200], emptyRowsWhenPaging: false, sorting: ((_b = props === null || props === void 0 ? void 0 : props.options) === null || _b === void 0 ? void 0 : _b.sorting) || false, draggable: ((_c = props === null || props === void 0 ? void 0 : props.options) === null || _c === void 0 ? void 0 : _c.draggable) || false, headerStyle: {
                    textTransform: 'capitalize',
                    position: 'sticky',
                }, actionsCellStyle: Object.assign(Object.assign({}, actionFlexStyle), { justifyContent: 'center', alignItems: 'center', height: (props === null || props === void 0 ? void 0 : props.actionsCellHeight)
                        ? props === null || props === void 0 ? void 0 : props.actionsCellHeight
                        : tableRowHeight }) }, props.options), title: props.title || '' })) })));
};
export default Table;
